/**
 * 开发工具模块
 * 负责初始化 vConsole（开发环境）和 DisableDevtool（生产环境）
 */

import DisableDevtool from 'disable-devtool'
import { isDebugMode } from '@/utils'

/**
 * 初始化 vConsole（仅在开发和测试环境）
 */
export async function initVConsole() {
  if (isDebugMode) {
    const { default: VConsole } = await import('vconsole')
    new VConsole()
  }
}

/**
 * 初始化防调试工具（仅在生产环境）
 */
export function initDisableDevtool() {
  if (!isDebugMode) {
    DisableDevtool({
      disableMenu: true,
      disableSelect: true,
      disableCopy: true,
      disableCut: true,
      disablePaste: true,
      clearLog: true,
      disableIframeParents: true,
      // 检测到开发者工具打开时，跳转到独立的警告页面（多页面应用，不依赖路由）
      ondevtoolopen: () => {
        window.location.href = `${window.location.origin}/devtool-warning.html`
      },
      tkName: 'ied',
      md5: '930028861b154f4780c789a89c7d63d7',
    })
  }
}
